import React, {useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import {Button} from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import {PfImage} from '@profabric/react-components';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import * as AuthService from '../../../services/auth';
import {toast} from 'react-toastify';

const ItemMember = (props) => {
  const StyledUserImage = styled(PfImage)``;
  return (
    <Card className="card bg-light">
      <Card.Body>
        <div className="col-12">
          <div className="row">
            <div className="col-2">
              <StyledUserImage
                src={props.img}
                fallbackSrc="/img/default-profile.png"
                width={48}
                height={48}
                rounded
              />
            </div>
            <div className="col-8">
              {`${props.index}. `} {props.name}
            </div>
            <div className="col-2">
              {props.mode === 'add' ? (
                <Button
                  className="btn-xs"
                  variant="outline-primary"
                  onClick={() => {
                    props.onAdd(props.empid);
                  }}
                >
                  &nbsp;&nbsp;เพิ่ม&nbsp;&nbsp;
                </Button>
              ) : (
                <Button
                  className="btn-xs"
                  variant="outline-primary"
                  onClick={() => {
                    props.onDelete(props.empid);
                  }}
                >
                  &nbsp;&nbsp;ลบ&nbsp;&nbsp;
                </Button>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default function TableGroup(props) {
  const [group, setGroup] = useState('');
  const [groups, setGroups] = useState([]);
  const [members2, setMembers2] = useState([]);
  const [members, setMembers] = useState([]);
  const [search, setSearch] = useState('');
  const [search2, setSearch2] = useState('');
  const [showMd, setShowMd] = useState(false);
  const [mode, setMode] = useState('');
  const handleMdNew = (mode, group_id) => {
    setShowMd(true);
    setGroup(group_id);
    setMode(mode);
    downloadMember(group_id);
  };

  const onAdd = async (empid) => {
    //group
    const input = {group_id: group, operation: 'add', empid: empid};
    const result = await AuthService.updateGroup(input);
    if (result.result === 'SUCCESS') {
      toast.success('แก้ไขสำเร็จแล้ว');
      downloadMember(group);
      onSearch();
    } else {
      toast.success('แก้ไขผิดพลาด');
    }
  };

  const onDelete = async (empid) => {
    const input = {group_id: group, operation: 'delete', empid: empid};
    const result = await AuthService.updateGroup(input);
    if (result.result === 'SUCCESS') {
      toast.success('แก้ไขสำเร็จแล้ว');
      downloadMember(group);
      onSearch();
    } else {
      toast.success('แก้ไขผิดพลาด');
    }
  };

  const onSearch = async () => {
    let _groups = await AuthService.downloadGroup(search);
    _groups = props.group_id ? _groups.filter((e)=>(props.group_id.includes(e.group_id))) : _groups;
    setGroups(_groups);
  };
  
  const onSearch2 = async () => {
    if (search2 === ''){
      toast.warning("กรุณาใส่คำค้นหา");
    }else{
      const _members = await AuthService.downloadEmployees(search2);
      setMembers2(_members);
    }
  };
  
  const downloadMember = async (group_id) => {
    const _members = await AuthService.downloadMember(group_id);
    console.log(_members);
    setMembers(_members);
  };

  const addGroupWs = (input) => {
    console.log(input);
    onCreate(input);
  };
  return (
    <div>
      <Modal show={showMd} size={'lg'} onHide={() => setShowMd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {mode === 'add' ? 'เพิ่มกลุ่ม' : 'แก้ไขกลุ่ม'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-6">
              <Card className="card">
                <Card.Header className="d-flex">
                  ค้นจากชื่อ รหัสพนักงาน หรืออีเมล์
                </Card.Header>
                <Card.Body>
                  <div className="col-12 mb-1">
                    <div className="ml-auto row">
                      <div className="input-group">
                        <input
                          value={search2}
                          type="text"
                          onChange={(event) => {
                            event.preventDefault();
                            setSearch2(event.target.value);
                          }}
                          className="form-control"
                          placeholder="ชื่อหรือรหัสพนักงาน"
                        />
                        <div className="input-group-append">
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={onSearch2}
                          >
                            ค้นหา
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-12 p-1 container"
                    style={{
                      height: '59vh',
                      width: '100%',
                      overflowY: 'scroll'
                    }}
                  >
                    {members2.map((e, i) => (
                      <ItemMember
                        onAdd={onAdd}
                        onDelete={onDelete}
                        mode={'add'}
                        key={`m-${i}`}
                        name={e.DisplayName}
                        empid={e.ID_Emp}
                        img={e.Image}
                        index={i + 1}
                      />
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className="col-6">
              <Card className="card">
                <Card.Header className="d-flex">สมาชิกปัจจุบัน</Card.Header>
                <Card.Body>
                  <div
                    className="col-12 p-1 container"
                    style={{
                      height: '64vh',
                      width: '100%',
                      overflowY: 'scroll'
                    }}
                  >
                    {members.map((e, i) => (
                      <ItemMember
                        onAdd={onAdd}
                        onDelete={onDelete}
                        mode={'delete'}
                        key={`m-${i}`}
                        name={e.DisplayName}
                        empid={e.ID_Emp}
                        img={e.Image}
                        index={i + 1}
                      />
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Card className="card">
        <div className={props.show ? 'd-none' : 'overlay dark'}>
          <span style={{color: 'white', fontSize: 30}}>{props.title ? props.title : "CR"} ONLY</span>
        </div>
        <Card.Header className="d-flex">
          <div className="mt-2">
            ค้นหากลุ่มด้วยชื่อกลุ่มหรือรหัสพนักงานคนในกลุ่ม (เช่น cr)
          </div>
          <div className="ml-auto row">
            <div className="input-group col-8">
              <input
                value={search}
                type="text"
                onChange={(event) => {
                  setSearch(event.target.value);
                }}
                className="form-control"
                placeholder="ชื่อหรือรหัสพนักงาน"
              />
              <div className="input-group-append">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={onSearch}
                >
                  ค้นหา
                </button>
              </div>
            </div>
            <Button
              disabled={true}
              variant="outline-primary"
              onClick={handleMdNew}
            >
              + เพิ่มกลุ่ม
            </Button>
          </div>
        </Card.Header>
        <Table striped>
          <thead>
            <tr>
              <th className="d-none d-sm-table-cell">#</th>
              <th className="d-none d-sm-table-cell">ชื่อกลุ่ม</th>
              <th className="d-none d-sm-table-cell">จำนวนสมาชิก</th>
              <th className="d-none d-lg-table-cell">ผู้สร้าง</th>
              <th>ดู / แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {groups ? (
              groups.map((e, i) => {
                return (
                  <tr key={`group-${i}`}>
                    <td className="d-none d-sm-table-cell">{e.group_id}</td>
                    <td className="d-none d-sm-table-cell">{e.group_name}</td>
                    <td className="d-none d-sm-table-cell">
                      {e.group_member.length}
                    </td>
                    <td className="d-none d-lg-table-cell">
                      {e.group_create_by}
                    </td>
                    <td>
                      <i
                        className="fas fa-search"
                        onClick={() => {
                          handleMdNew('edit', e.group_id);
                        }}
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <></>
            )}
          </tbody>
        </Table>
      </Card>
    </div>
  );
}
